import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { X, ArrowLeft } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const IUBENDA_PRIVACY_URL = "https://www.iubenda.com/privacy-policy/7870512";

export default function PrivacyPolicy({ onClose }) {
    const { language } = useLanguage();

    // Blocca lo scroll del body mentre il modale è aperto
    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "";
        };
    }, []);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[200] bg-black/80 backdrop-blur-sm flex flex-col"
        >
            {/* Header */}
            <div className="flex-shrink-0 bg-[--bg-primary]/95 backdrop-blur-sm border-b border-[--border-color]">
                <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
                    <button
                        onClick={onClose}
                        className="flex items-center gap-2 text-[--text-secondary] hover:text-[--accent] transition-colors"
                    >
                        <ArrowLeft className="w-5 h-5" />
                        <span>{language === "it" ? "Torna alla Home" : "Back to Home"}</span>
                    </button>
                    <div className="flex items-center gap-3">
                        <a
                            href={IUBENDA_PRIVACY_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[--accent] text-sm hover:underline hidden sm:inline"
                        >
                            {language === "it" ? "Apri in nuova scheda" : "Open in new tab"} ↗
                        </a>
                        <button
                            onClick={onClose}
                            className="w-10 h-10 rounded-full bg-[--accent]/20 flex items-center justify-center hover:bg-[--accent] transition-colors group"
                            aria-label="Chiudi"
                        >
                            <X className="w-5 h-5 text-[--accent] group-hover:text-black transition-colors" />
                        </button>
                    </div>
                </div>
            </div>

            {/* Iframe Iubenda */}
            <div className="flex-1 overflow-hidden">
                <iframe
                    src={IUBENDA_PRIVACY_URL + "?an=no&s=1"}
                    title="Privacy Policy"
                    className="w-full h-full border-0 bg-white"
                    loading="lazy"
                    sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                />
            </div>
        </motion.div>
    );
}
